export default __webpack_public_path__ + "media/src/images/drag_icon-0de5f917eca849e564cc6a6d95ceea64.svg";